import { useCubeImages } from '@/composables/useCubeImages.ts';
import { useAccountStore } from '@/stores/useAccountStore';
import { useCubeStore } from '@/stores/useCubeStore';
import { storeToRefs } from 'pinia';

export function useMyCube() {
  const { isDemoUser } = storeToRefs(useAccountStore())
  const {
    name: cubeName,
    nickName: nickname,
    hasProduction,
    hasConsumption,
    unusedEnergyLines,
    isGrantedGridFeeDiscount,
  } = storeToRefs(useCubeStore())

  const { thumbnailUrl, iconUrlPng, iconUrlSvg, imageUrl } = useCubeImages(cubeName)

  return {
    cubeName,
    nickname,
    hasProduction,
    hasConsumption,
    unusedEnergyLines,
    isDemoUser,
    thumbnailUrl,
    iconUrlPng,
    iconUrlSvg,
    imageUrl,
    isGrantedGridFeeDiscount
  }
}
